module.exports = __webpack_public_path__ + "img/xp-tb.57e37d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb.png
// module id = FI1g
// module chunks = 39 44